/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetNumberOfEmploymentsRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetNumberOfEmploymentsResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getNumberOfEmployments = (request: GetNumberOfEmploymentsRequest, options?: CashRequestOptions) => post<GetNumberOfEmploymentsRequest, GetNumberOfEmploymentsResponse>("/2.0/cash/get-number-of-employments", request, {...options, rejectOnError: true })